import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=537ad0c3&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=537ad0c3&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537ad0c3')) {
      api.createRecord('537ad0c3', component.options)
    } else {
      api.reload('537ad0c3', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=537ad0c3&", function () {
      api.rerender('537ad0c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/Edit.vue"
export default component.exports